module.exports = __webpack_public_path__ + "static/media/easyflex.01635cc9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/easyflex.webp
// module id = 544
// module chunks = 0